import axios from "../common.js";
import store from "../../store/index";
import { testR } from "../common";

/**
 *  创建威富通商户号
 * /swiftpass/v2/configure/generate
 */
export const swiftConfigure = function(datas) {
  var data = {
    ...datas
  };
  axios.defaults.headers = {
    Authorization: `Token token_type=${localStorage.getItem(
      "token_type"
    )}&access_token=${localStorage.getItem("access_token")}`
  };
  return axios.post("swiftpass/v2/configure/generate", JSON.stringify(data));
};

/**
 * 获取威富通信息
 *
 */
export const swiftQuery = function(mch_no, pass_word) {
  axios.defaults.headers = {
    Authorization: `Token token_type=${localStorage.getItem(
      "token_type"
    )}&access_token=${localStorage.getItem("access_token")}`
  };
  var data = {
    pass_word
  };
  return axios.post(
    "swiftpass/v2/configure/query?mch_no=" + mch_no,
    JSON.stringify(data)
  );
};
/**
 * 修改
 */
export const swiftModify = function(datas) {
  var data = {
    ...datas
  };
  axios.defaults.headers = {
    Authorization: `Token token_type=${localStorage.getItem(
      "token_type"
    )}&access_token=${localStorage.getItem("access_token")}`
  };
  return axios.post("swiftpass/v2/configure/modify", JSON.stringify(data));
};

/**
 * 获取所有威富通商户
 * swiftpass/v2/configure/list
 */
export const swiftGetList = function() {
  /* axios.defaults.headers = {
    Authorization: `Token token_type=${localStorage.getItem(
      "token_type"
    )}&access_token=${localStorage.getItem("access_token")}`
  }; */
  return new Promise((resolve, reject) => {
    axios.get("swiftpass/v2/configure/list").then(res => {
      if (res.data && res.data.resp_data && res.data.resp_data.state == "OK") {
        resolve(res.data.resp_data.items);
      }
    });
  });
};
